import Vue from 'vue'
import { findIndex, isEqual, size } from 'lodash'

const mutations = {
    setLastUuRequestKey(state, { item, key }) {
        if (item) {
            state.lastUuRequestKey[item] = key
        } else {
            state.lastUuRequestKey = key
        }
    },

    setIsLoading(state, { item, isLoading }) {
        if (item) {
            if (typeof item === 'string') Vue.set(state.isLoading, item, isLoading)
            else Vue.set(state.isLoading[item[0]], item[1], isLoading)
        } else {
            Vue.set(state, 'isLoading', isLoading)
        }
    },

    setSelectedRow(state, { rowId, from }) {
        Vue.set(state, 'selectedRowId', rowId)
        Vue.set(state, 'selectedRowFrom', from ? from : null)
    },

    setSelectedTag(state, { tagLabel }) {
        Vue.set(state, 'selectedTagLabel', tagLabel)
    },

    setExpandedRows(state, { id }) {
        if (state.expandedRows.indexOf(id) > -1) {
            const indexOfItemToRemove = findIndex(state.expandedRows, segmentId => isEqual(segmentId, id))
            Vue.delete(state.expandedRows, indexOfItemToRemove)
        } else {
            const index = size(state.expandedRows)
            Vue.set(state.expandedRows, index, id)
        }
    },

    //needed in ui/monitoring to get filtered audiences infos
    setFilteredData(state, { items }) {
        Vue.set(state, 'filteredData', items)
    },

    setDisplayModal(state, { item, display }) {
        if (item) {
            Vue.set(state.displayModal, `${item}`, display)
        } else {
            Vue.set(state, 'displayModal', display)
        }
    },

    // Block Filter
    setSearchFilter(state, { filter, value }) {
        state.searchFilters[filter] = state.searchFilters[filter] === null || state.searchFilters[filter] !== value ? value : null
    },

    setActiveTab(state, { tab }) {
        Vue.set(state, 'activeTab', tab)
    }
}

export default mutations
